<template>
	<main class="main" @scroll="onScroll($event)">
		<header ref="mainHeader" class="main__header">
			<img class="image image--circular image--medium image--bordered image--centered" src="@/assets/me.jpg" alt="A picture of me">
			<h1 class="heading">
				<div class="heading__title">Matthew A. Steven</div>
				<div class="heading__subtitle">Front-End Web Developer | Columbia, SC</div>
			</h1>
		</header>
		<div class="container">
			<p>Hello! I am a front-end developer, and have {{ new Date().getFullYear() - 2013 }} years on-the-job experience in coding, usability design/testing, and accessibility testing responsive websites. I have dabbled in visual design, and develop full-stack websites in my spare time.</p>
			<p>I graduated from <a href="http://www.clemson.edu/" target="_blank">Clemson University</a> in the <a href="http://www.clemson.edu/degrees/computer-science" target="_blank">Computer Science Bachelor of Arts</a> program, with a minor in <a href="https://www.cs.clemson.edu/dpa/" target="_blank">Digital Production Arts</a>. I want to create awesome websites, and I'm always up for a new challenge!</p>
			<ul class="icon-links icon-links--separator">
				<li class="icon-links__item">
					<router-link class="icon-links__link" to="/resume">
						<span class="fas fa-file-alt"></span>
						Resume
					</router-link>
				</li>
			</ul>
			<!--section ref="projectsSection" class="main__section">
				<h1 class="heading">
					<div class="heading__title">Projects</div>
					<div class="heading__subtitle">A Showcase of My Work</div>
				</h1>
			</section-->
			<section ref="contactSection" class="main__section">
				<h1 class="heading">
					<div class="heading__title">Contact</div>
				</h1>
				<div class="container container--fit">
					<ul class="list list--basic list--icons list--centered">
						<li>
							<span class="fas fa-envelope"></span>
							<a href="mailto:masteve@g.clemson.edu" target="_blank">masteve@g.clemson.edu</a>
						</li>
						<li>
							<span class="fas fa-phone"></span>
							<a href="tel:18646081101" target="_blank">+1 (864) 608-1101</a>
						</li>
						<li>
							<span class="fab fa-linkedin"></span>
							<a href="https://linkedin.com/in/matthew-steven-8914a7100" target="_blank">LinkedIn</a>
						</li>
					</ul>
				</div>
			</section>
		</div>
	</main>
</template>

<script>
	import scrollIntoView from 'scroll-into-view-if-needed';
	export default {
		name: 'HomePage',
		data() {
			return {
				isAutoScroll: false
			};
		},
		watch: {
			$route(to, from) {
				this.handleRouteScroll(to.path);
			}
		},
		mounted() {
			this.handleRouteScroll(this.$route.path);
		},
		methods: {
			handleRouteScroll(path) {
				let scrollNode;

				if (path === '/about') {
					scrollNode = this.$refs.mainHeader;
				}
				else if (path === '/contact') {
					scrollNode = this.$refs.contactSection;
				}

				if (scrollNode) {
					this.isAutoScroll = true;
					scrollIntoView(scrollNode, {
						behavior: 'smooth',
						block: 'start'
					});
					setTimeout(() => {
						this.isAutoScroll = false;
					}, 1000);
				}
			},
			onScroll() {
				if (!this.isAutoScroll) {
					this.$router.replace('/');
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/HomePage.vue